import { combineReducers, configureStore } from "@reduxjs/toolkit";
import Careseeker from "./Slices/Careseeker";
import SubAdmin from "./Slices/SubAdmin";
import PromotionSlice from "./Slices/PromotionSlice";
import BookingSlice from "./Slices/BookingSlice";
import WifilistSlice from "./Slices/WifilistSlice";
import PackageBenefitsSlice from "./Slices/PackageBenefitsSlice";
import ChecklistSlice from "./Slices/ChecklistSlice";
import CommissionSlice from "./Slices/CommissionSlice";
import TransactionSlice from "./Slices/TransactionSlice";
import NotificationTemplateSlice from "./Slices/NotificationTemplateSlice";
import VerificationSlice from "./Slices/VerificationSlice";
import EmailHistorySlice from "./Slices/EmailHistorySlice";
import KbSlice from "./Slices/KbSlice";
import SupportKbSlice from "./Slices/SupportKbSlice";

const rootReducer = combineReducers({
  careseeker: Careseeker,
  SubAdmin: SubAdmin,
  Promotion: PromotionSlice,
  Booking: BookingSlice,
  Wifi: WifilistSlice,
  PackageBenefits: PackageBenefitsSlice,
  Checklist: ChecklistSlice,
  Commission: CommissionSlice,
  Transaction: TransactionSlice,
  NotificationTemplates: NotificationTemplateSlice,
  Verification: VerificationSlice,
  emailHistory: EmailHistorySlice,
  kb: KbSlice,
  supportKb: SupportKbSlice,
});

export const Store = configureStore({
  reducer: rootReducer,
});
